import PropTypes from 'prop-types';

export default PropTypes.shape({
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  label: PropTypes.node,
  content: PropTypes.node,
});
